import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { ContactService } from '../../../services/ContactService'
import { maptoImportContactsReportResponse } from '../../../models/conversations'
import GridComponent from '../../shared/grid'
import { useSelector } from 'react-redux'
import * as selector from '../../../selectors/selectors';
import { ColDef, ICellRendererParams, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import { dateComparator } from '../../shared/grid/grid.services'
import { UtilityService } from '../../../services/UtilityService'
import ContactHistoryInfo from './Contact-history-info'
import { ClioHistoryIcon, CsvColorIcon, ExcelColorIcon, HubspotHistoryIcon, MicroSoftImportContacts } from '../../../icon'
import { MessageService } from '../../../services/MessageService'
import { ImportReportResponse, maptoImportReportResponse } from '../../../models/conversations/schedule-messages.model'
import { ImportSource, ImportType } from '../../../models/reports.model'

interface Props {
    IsContacts: boolean;
    IsScheduleMessages: boolean;
    GridHeader: string;
}

const ImportContactsHistory = (props: Props) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)


    const [data, setData] = useState<ImportReportResponse[]>()
    const [gridApi, setGridApi] = useState<any>();
    const [columnApi, SetColumnApi] = useState<any>(null)
    const [open, setopen] = useState<boolean>(false)
    const [selectedRow, setSelectedRow] = useState<ImportReportResponse>();

    const ColoumnDefs: ColDef[] = [
        {
            field: "Source",
            headerName: "Import Label",
            valueGetter: (params: ValueGetterParams) => {
                return `${params.data.Source}`
            },
            cellRenderer: (params: ICellRendererParams) => {
                return <>{
                    (params.data.Source === "File" || params.data.Source === "XLSX") ?
                        <ExcelColorIcon className='w-4 h-4 mr-2' /> :
                        params.data.Source === "Outlook" ?
                            <MicroSoftImportContacts className='w-4 h-4 mr-2' /> : params.data.Source === "Clio" ? <ClioHistoryIcon className='mr-3' /> : params.data.Source === "CSV" ? <CsvColorIcon className='w-4 h-4 mr-2' /> : <HubspotHistoryIcon className='mr-3' />
                }
                    {params.data.Source}
                </>
            },
            autoHeight: IsMobileDevice ? true : false,
            resizable: true,
            minWidth: IsMobileDevice ? null : 200,
        },
        {
            field: "SavedContacts",
            headerName: "Record Created",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.SavedRecords
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                return undefined
            },
            autoHeight: IsMobileDevice ? true : false,
            resizable: true,
            minWidth: IsMobileDevice ? null : 200,
        },
        {
            field: "IgnoredContacts",
            headerName: "Record Skipped",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.IgnoredRecords
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                return undefined
            },
            autoHeight: IsMobileDevice ? true : false,
            resizable: true,
            minWidth: IsMobileDevice ? null : 200,
        },
        {
            field: "clioHubspotAddedContacts",
            headerName: "Record Clio/HubSpot Added",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.ClioHubspotAddedRecords
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                return undefined
            },
            autoHeight: IsMobileDevice ? true : false,
            resizable: true,
            minWidth: IsMobileDevice ? null : 200,
            hide: props.IsScheduleMessages
        },
        {
            field: "ExistingContacts",
            headerName: "Record Existing",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.ExistingRecords
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                return undefined
            },
            autoHeight: IsMobileDevice ? true : false,
            resizable: true,
            minWidth: IsMobileDevice ? null : 200,
            hide: props.IsScheduleMessages
        },

        {
            field: "Total Records",
            headerName: "Total Records",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.SavedRecords + params.data.IgnoredRecords + params.data.ExistingRecords
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                return undefined
            },
            autoHeight: IsMobileDevice ? true : false,
            resizable: true,
            minWidth: IsMobileDevice ? null : 200,
        },
        {
            field: "CreatedBy",
            headerName: "Import by",
            valueGetter: (params: ValueGetterParams) => {
                return `${params.data?.CreatedBy} `
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                return undefined
            },
            autoHeight: IsMobileDevice ? true : false,
            resizable: true,
            minWidth: IsMobileDevice ? null : 200,
        },
        {
            field: "CreatedDateTime",
            headerName: "Updated Date",
            valueFormatter: (params: ValueFormatterParams) => {
                return UtilityService.convertDateToDay(params.data.CreatedDateTime).toString()
            },

            sort: !IsMobileDevice ? 'desc' : null,
            hide: IsMobileDevice,
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.CreatedDateTime, nodeB.data.CreatedDateTime),
            minWidth: 150,
            width: 150,
            maxWidth: 150,
            suppressSizeToFit: true
        },
        {
            field: "Status",
            headerName: "Status",
            valueGetter: (params: ValueGetterParams) => {
                return `${params.data.Status} `
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                return undefined
            },
            autoHeight: IsMobileDevice ? true : false,
            resizable: true,
            minWidth: IsMobileDevice ? null : 200,
        },
    ]

    const getImportContactsHistory = () => {
        ContactService.allContactsImportReports().then(res => {
            console.log("res:", res.data[0].savedContacts)
            setData(res.data.map(x => maptoImportContactsReportResponse(x)))
        }).catch(err => {
            console.log("err:", err)
        }).finally(() => {
        })
    }

    //on mount 
    useEffect(() => {
        if (props.IsContacts) {
            getImportContactsHistory()
        }
        else {
            MessageService.getAllScheduleReports().then((res) => {
                setData(res.data.map(x => maptoImportReportResponse(x)))
            }).catch(err => {
                console.log(err)
            })
        }
    }, [])

    const GridReady = (params: any): void => {
        setGridApi(params.api)
        SetColumnApi(params.columnApi)
    }

    const handleRowClick = (row: any) => {
        setSelectedRow(row)
        setopen(true);
    }

    const closeGroupInfoPopup = () => {
        setopen(null);
    }

    return (
        <div className="px-1">
            <Box className="pt-4">
                <Box className="h3-semibold py-2 px-4 bg-color-border-color">{props.GridHeader}</Box>
            </Box>
            <div className="h-v-50">
                <GridComponent
                    ColumnDefs={ColoumnDefs}
                    RowData={data}
                    OnGridReady={GridReady}
                    IsPaginationEnabled={false}
                    EmptyLabel={'No history is available'}
                    LockVisible={IsMobileDevice}
                    gridApi={gridApi}
                    OnGridRowClick={handleRowClick}
                    isHorizontalScroll={true}
                    ShowRowPointer={true}
                />
            </div>
            {open &&
                <ContactHistoryInfo
                    Open={open}
                    HandleClose={closeGroupInfoPopup}
                    Contact={selectedRow}
                    Source={selectedRow.Source}
                    Data={{
                        TotalRecords: selectedRow.SavedRecords + selectedRow.IgnoredRecords,
                        SavedRecords: selectedRow.SavedRecords,
                        ExistingRecords: selectedRow?.ExistingRecords,
                        IgnoredRecords: selectedRow.IgnoredRecords,
                        Source: ImportSource.Excel,
                        ReportId: selectedRow.Id,
                        Type: props.IsContacts ? ImportType.Contacts : ImportType.ScheduledMessages,
                    }}
                />
            }
        </div>
    )
}

export default ImportContactsHistory